import PropTypes from 'prop-types'
import moment from 'moment'

const date_t = PropTypes.oneOfType([PropTypes.objectOf(Date), PropTypes.objectOf(moment.Moment), PropTypes.string])

const project_info_t = PropTypes.shape({
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  status_date: date_t,
  data_omitted: PropTypes.bool.isRequired
})

export {project_info_t}

const task_status_t = PropTypes.oneOf([
  'STARTED_AHEAD_OF_SCHEDULE',
  'STARTED_BEHIND_SCHEDULE',
  'COMPLETE',
  'NOT_STARTED_BEHIND_SCHEDULE',
  'NOT_STARTED_ON_SCHEDULE'
])


const task_t = PropTypes.shape({
  acttask_id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  start: date_t,
  finish: date_t,
  duration: PropTypes.number,
  status: task_status_t.isRequired,
  critical: PropTypes.bool.isRequired,
  fixed_cost: PropTypes.number,  
  resource_cost: PropTypes.number,
  total_cost: PropTypes.number,
  wbs: PropTypes.string
})


export {task_status_t, task_t}

const dataset_state_t = PropTypes.oneOf(['fresh', 'updated_locally', 'local'])

const dataset_t = PropTypes.shape({
  dataset_guid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  state: dataset_state_t,
  data_omitted: PropTypes.bool.isRequired,
  status_date: date_t
})

export {dataset_state_t, dataset_t}




// WEBPACK FOOTER //
// ./src/etc/common-props.js